<template>
  <div class="">
    <div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow.png'"/><span
      class="linkto" @click="toNotice">申报通知</span><img :src="imgUrl+'double_arrow.png'"/><span>详情</span></div>

    <div class="notidetail_outer">
      <div class="notidetail_cont">
        <div class="head">
          <div class="tit" v-text="detail.post_title">
          </div>
          <div class="info">
            <span v-if="detail.level" v-text="'申报层级：'+detail.level"></span>
            <span v-if="detail.dept" v-text="'职能部门：'+detail.dept"></span>
            <span v-if="detail.end_time" v-text="'申报时限：'+detail.end_time"></span>
            <span v-if="detail.published_time" v-text="'发布时间：'+detail.published_time"></span>
          </div>
        </div>
        <div class="paragraph" v-html="detail.post_content"></div>
        <div class="additional">
          <div>附件</div>
          <div class="a_list" v-for="(item,index) in detail.files">
            <div class="item"  @click="downloadFile(item.url,item.name)"><span class="item_url" v-text="index+1+'. '+item.name"></span></div>
          </div>
        </div>
        <div class="btn_outer btn_outer_fav" v-if="vt">
          <el-button type="danger"   v-if="detail.followed" @click="cancelFav">
            <div>已关注</div>
            <i class="cloudicon ci_fav"></i></el-button>
          <el-button type="danger" plain @click="addToFav" v-if="!detail.followed">
            <div>关注</div>
            <i class="cloudicon ci_fav"></i></el-button>
          <el-button type="primary" v-if="detail.available" plain @click="toDeclare">
            <div>申报</div>
            <i class="cloudicon ci_back"></i></el-button>
        </div>
        <div class="btm_tip" v-if="detail.level!='工业综合开发区'&&vt">
          注：需要先在工业区申报取得同意书，再去区平台申报。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.detail = {};
    let id = this.$route.query.id;
    let vt = this.$route.query.type;
    if(vt=='公告'||vt=='通知'){
    	this.vt = false
    }else{this.vt = true}
    this.id = id;
    this.$ajax.get(this.bUrl + 'api/portal/articles/read?id=' + id)
      .then(function (res) {
        this.detail = res.data.data;
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },
  name: 'notidetail',
  data() {
    return {
    	vt:true,
      id: -1,
      detail: {
        post_title: "",
        published_time: "",
        post_content: "",
        level: "奉贤区级",
        dept: "人社局",
        end_time: "2020-08-29",
        files: [
          {
            url: "/upload/portal/20200828/e7bc5a7985c91de2be6089cbc6c6b782.zip",
            name: "msvcr120.zip"
          }
        ]
      },
    }
  },
  watch: {
    $route(to, from) {
      this.detail = {};
      let vt = this.$route.query.type;
	    if(vt=='公告'||vt=='通知'){
	    	this.vt = false
	    }else{this.vt = true}
      let id = to.query.id;
      this.id = id;
      this.$ajax.get(this.bUrl + 'api/portal/articles/read?id=' + id)
        .then(function (res) {
          this.detail = res.data.data;
        }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
    }
  },

  methods: {
    toDeclare() {
    	this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
      .then(function (res) {
    	  if(res.data.code!=200){
	        this.$message.error(res.data.msg);
	      }else{
	      	let roleId = JSON.parse(localStorage.getItem('gyzhqy_user_info')).role_id
					let userType = JSON.parse(localStorage.getItem('gyzhqy_user_info')).user_type
					if(userType==2){
						if(roleId.indexOf(2)<0){
							this.$message.error('抱歉！您没有访问权限');
							return
						}
					}
	      	if (this.detail.level === '工业综合开发区') {
		        this.$router.push({name: 'declare', query: {policy_id: this.id,fname:'notidetail'}})
		      } else {
		        this.$router.push({name: 'declare2', query: {policy_id: this.id,fname:'notidetail'}})
		      }
	      }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

    },
    toNotice() {
      this.$router.push({name: 'notilist'})
    },
    tohome() {
      this.$router.push({name: 'homepage'})
    },
    async addToFav() {
      let res = await this.$ajax.post(this.bUrl + '/api/portal/articles/dofavorite?id=' + this.id);
      if (res.data.code === 200) {
        this.$message.success(res.data.msg);
        this.detail.followed=true;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    cancelFav(){
      this.$ajax.post(this.bUrl+'api/portal/articles/cancelfavorite?id=' + this.id)
				.then(function(res) {
          if(res.data.code==200){
            this.detail.followed = false
            this.$message.success(res.data.msg);
          }else {
            this.$message.error(res.data.msg);
          }
				}.bind(this))
				.catch(function(error) {
					console.log(error);
				});
    },
    downloadFile(url,name) {
      if(url.indexOf('http://')==0){
        url = url.replace(/http:\/\//,'https://')
      }
//    window.location.href = url;
      this.$down.download (url, name)
    }

  }
}
</script>

<style scoped>
.notidetail_outer {
  background: #fff;
}

.notidetail_cont {
  width: 1180px;
  margin: 0 auto;
  padding:36px 66px;
  box-sizing: border-box;
  color: #666666;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  /*margin-top: 34px;*/
}

.notidetail_cont .head {
  text-align: center;
  margin-bottom: 20px;
}

.notidetail_cont .head .tit {
  font-size: 24px;
  color: #5F5F5F;
}

.notidetail_cont .head .info {
  padding: 0 150px;
  display: flex;
  justify-content: space-around;
  line-height: 40px;
  font-size: 12px;
  color: #666666;
}

.notidetail_cont .paragraph {
  margin: 0 90px;
}

.additional {
  background: #F0F5F8;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  padding: 28px;
  margin: 32px 24px 56px 24px;
  color: #143367;
}

.additional .a_list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
}

.additional .a_list .item {
  width: 40%;
  margin-right: 10%;
  line-height: 40px;
}

.btn_outer {
  text-align: center;
  font-size: 20px;
}

.btn_outer .ci_back {
  font-size: 24px;
  margin-left: 10px;
  display: inline-block;
  transform: rotate(180deg);
}

.btn_outer .ci_fav {
  margin-left: 10px;
  font-size: 30px;
}

.btm_tip {
  text-align: right;
  margin-right: 24px;
  margin-top: 50px;
}

.item_url {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/notidetail.vue